export enum SectionType {
	SERIAL = 'SERIAL',
	PARALLEL = 'PARALLEL',
}
